import script from "./ProtectedAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProtectedAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./ProtectedAvatar.vue?vue&type=style&index=0&id=fc7ca608&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc7ca608"]])

export default __exports__